var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "14",
        viewBox: "0 0 18 14",
        fill: "none",
      },
    },
    [
      _c("g", { attrs: { "clip-path": "url(#clip0_503_17078)" } }, [
        _c("path", {
          attrs: {
            d: "M8.99922 0C6.47422 0 4.45234 1.15 2.98047 2.51875C1.51797 3.875 0.539844 5.5 0.0773437 6.61562C-0.0257813 6.8625 -0.0257813 7.1375 0.0773437 7.38437C0.539844 8.5 1.51797 10.125 2.98047 11.4812C4.45234 12.85 6.47422 14 8.99922 14C11.5242 14 13.5461 12.85 15.018 11.4812C16.4805 10.1219 17.4586 8.5 17.9242 7.38437C18.0273 7.1375 18.0273 6.8625 17.9242 6.61562C17.4586 5.5 16.4805 3.875 15.018 2.51875C13.5461 1.15 11.5242 0 8.99922 0ZM4.49922 7C4.49922 5.80653 4.97332 4.66193 5.81724 3.81802C6.66115 2.97411 7.80574 2.5 8.99922 2.5C10.1927 2.5 11.3373 2.97411 12.1812 3.81802C13.0251 4.66193 13.4992 5.80653 13.4992 7C13.4992 8.19347 13.0251 9.33807 12.1812 10.182C11.3373 11.0259 10.1927 11.5 8.99922 11.5C7.80574 11.5 6.66115 11.0259 5.81724 10.182C4.97332 9.33807 4.49922 8.19347 4.49922 7ZM8.99922 5C8.99922 6.10313 8.10234 7 6.99922 7C6.77734 7 6.56484 6.9625 6.36484 6.89687C6.19297 6.84062 5.99297 6.94688 5.99922 7.12813C6.00859 7.34375 6.03984 7.55937 6.09922 7.775C6.52734 9.375 8.17422 10.325 9.77422 9.89688C11.3742 9.46875 12.3242 7.82188 11.8961 6.22188C11.5492 4.925 10.4023 4.05312 9.12734 4C8.94609 3.99375 8.83984 4.19062 8.89609 4.36562C8.96172 4.56562 8.99922 4.77812 8.99922 5Z",
            fill: "#1A7BEE",
          },
        }),
      ]),
      _c("defs", [
        _c("clipPath", { attrs: { id: "clip0_503_17078" } }, [
          _c("rect", { attrs: { width: "18", height: "14", fill: "white" } }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }